
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class WrappedText extends Vue {
  /**
   * Get the line height of the given font size.
   */
  public getLineOpts(size) {
    let temp = document.createElement('span')
    temp.setAttribute('style', `position:absolute;font-size:${size};`)
    temp.innerHTML = 'test'
    temp = document.body.appendChild(temp)
    const lineHeight = temp.clientHeight
    const fontSize = window
      .getComputedStyle(temp, null)
      .getPropertyValue('font-size')
    const fontFamily = window
      .getComputedStyle(temp, null)
      .getPropertyValue('font-family')
    temp.parentNode.removeChild(temp)
    return { lineHeight, fontSize, fontFamily }
  }

  /**
   * Wrap text to fit.
   */
  public wrapText(
    context: CanvasRenderingContext2D,
    text: string,
    x: number,
    y: number,
    maxWidth: number,
    size: string | number
  ) {
    let words = text.split(' ')
    const lines = []
    let line = ''
    const { lineHeight, fontSize, fontFamily } = this.getLineOpts(size)

    context.font = `${fontSize} ${fontFamily}`

    for (var n = 0; n < words.length; n++) {
      const testLine = line + words[n] + ' '
      const metrics = context.measureText(testLine)
      const testWidth = metrics.width
      if (testWidth > maxWidth && n > 0) {
        context.fillText(line, x, y)
        line = words[n] + ' '
        y += lineHeight * 0.75
      } else {
        line = testLine
      }
    }

    context.fillText(line, x, y)
  }
}
